import { z } from 'zod';

export const OriginationBalances = z.object({
  interest: z.number(),
  escrow: z.number(),
  reserve: z.number().optional(),
});
export type OriginationBalances = z.infer<typeof OriginationBalances>;
